import { createAction } from "../../utilities/ActionUtility";

export const CLEAR_ALL = "ErrorAction.CLEAR_ALL";
export const REMOVE_BY_ID = "ErrorAction.REMOVE_BY_ID";
export const REMOVE_BY_TYPE = "ErrorAction.REMOVE_BY_TYPE";

export function removeById(id) {
    return createAction(REMOVE_BY_ID, id);
}

export function removeByType(type) {
    return createAction(REMOVE_BY_TYPE, type);
}

export function clearAll() {
    return createAction(CLEAR_ALL);
}
